import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.auth.AuthWarningPopup', {
    title: 'Your session will expire in {time}',
    description: 'Looks like you are inactive for a long time already. Please let us know if you are still there.',
    continueButton: 'Continue working',
});
